export const REDUCER_NAME = "CONTACTS_LIST";


